export const ApprovalActions = {
  PUBLISH: 'PUBLISH',
  MOVE_STAGE: 'MOVE_STAGE',
  INSTALL: 'INSTALL'
};